/**
 * 获取sessionStorage
 * @returns {Storage}
 */
function sessionStorage() {
	return window.sessionStorage
}

/**
 * * sessionStorage 取值
 * @param key
 * @param value
 */
function set(key, value) {
	if (typeof value == 'string') {
		sessionStorage().setItem(key, value)
	} else {
		sessionStorage().setItem(key, JSON.stringify(value))
	}
}

/**
 * sessionStorage 取值
 * @param key
 * @returns {string|any}
 */
function get(key) {
	const str = sessionStorage().getItem(key)
	if (typeof str == 'string') {
		try {
			return JSON.parse(str)
		} catch (e) {
			return str
		}
	}
	return
}

function all() {
	const data = {}
	for (var i = sessionStorage().length - 1; i >= 0; i--) {
		var key = sessionStorage().key(i)
		data[key] = get(key)
	}

	return data
}
function size() {
	return sessionStorage().length
}

function remove(key) {
	return sessionStorage().removeItem(key)
}

function clearAll() {
	return sessionStorage().clear()
}

function has(key) {
	return sessionStorage().getItem(key) !== null
}

export default {
	remove,
	clearAll,
	size,
	has,
	all,
	set,
	get
}
